import Grid from "@material-ui/core/Grid";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

import IRouterComponentProps from "../../models/IRouterComponentProps";
import PaymentAgreementModal from "../../common/elements/PaymentAgreementModal";
import { StyledModal } from "../../common/materials/GenericStyleComponent";
import NewHeader from "../header/new-Header/NewHeader";
import AuthService from "../auth/AuthService";

const StyledContainer = styled.div`
  margin: 0 auto;
  padding: 0;
  display: flex;
  overflow: auto;
`;

const StyledGridMainContainer = styled(Grid)`
  padding: 0px;
  flex-grow: 1;
  margin: 0px;
  width: calc(100% - 240px);
  ${(props) => props.theme.breakpoints.between("xs", "sm")} {
    margin-top: 0px;
  }
`;

const ChildrenDiv = styled(Grid)`
  margin-top: 55px;

  ${(props) => props.theme.breakpoints.between("xs", "sm")} {
    margin-top: 55px;
    padding-left: 0 !important;
  }
  ${(props) => props.theme.breakpoints.only("xs")} {
    margin-top: 25px;
  }
`;

export interface IAppLayoutProps extends IRouterComponentProps {
  children: any;
  t?: any;
}

const AppLayout = (props: IAppLayoutProps) => {
  const [agreementModalOpen, setAgreementModalOpen] = useState(false);
  const Auth = new AuthService();
  const { children, t } = props;

  useEffect(() => {
    const isLoggedIn = Auth.loggedIn();
    if (!isLoggedIn) return;

    // Retrieve timestamp of last shown popup
    const lastShown = localStorage.getItem("paymentAgreeLastShown");
    const now = new Date().getTime();

    // If never shown or more than 72 hours passed
    if (!lastShown || now - Number(lastShown) > 72 * 60 * 60 * 1000) {
      setAgreementModalOpen(true);
    }
  }, []);

  // Ensure the drawer icon state persists normally
  let isShowDrawerIcon: any = localStorage.getItem("isShowDrawerIcon");
  isShowDrawerIcon = JSON.parse(isShowDrawerIcon);
  if (isShowDrawerIcon === null) {
    localStorage.setItem("isShowDrawerIcon", "false");
  }

  const renderPaymentAgreement = () => (
    <StyledModal open={agreementModalOpen} className="PaymentAgreementModal">
      <PaymentAgreementModal
        closeModal={() => {
          setAgreementModalOpen(false);
          // Save current timestamp — independent of login state
          localStorage.setItem(
            "paymentAgreeLastShown",
            new Date().getTime().toString()
          );

          //Also set a flag to prevent app clearing this key on logout
          localStorage.setItem("paymentConditionAgree", "true");
        }}
      />
    </StyledModal>
  );

  return (
    <StyledContainer className="rootContainer">
      <NewHeader />
      <StyledGridMainContainer container spacing={0} className="mainContainer">
        <ChildrenDiv item xs={12} className="contentContainer">
          {children}
        </ChildrenDiv>
      </StyledGridMainContainer>
      {agreementModalOpen && renderPaymentAgreement()}
    </StyledContainer>
  );
};

export default AppLayout;
